import { Link } from 'react-router';

import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// The Dashboard's card of invitations nobody has answered yet, with how many
// there are. Each row names the invited address, or the name the clinician
// gave it, and leads to Invite patient, where it can be sent again or
// withdrawn.
export function InvitationsWaiting({ invitations }) {
  const { text, language } = useLanguage();

  const waiting = invitations.filter(function({ status }) {
    return status === 'PENDING';
  });

  let rows = <p className={ styles.empty }>{ text.noInvitationsWaiting }</p>;

  if (waiting.length > 0) {
    rows = waiting.map(function({ id, email, name, sentAt }) {
      let who = email;

      if (name != null) {
        who = name;
      }

      return (
        <Link key={ id } className={ styles.row } to='/patients/invite'>
          <span className={ styles.lines }>
            <span className={ styles.who }>{ who }</span>
            <span className={ styles.detail }>{ text.invitedNotAnswered.replace('{date}', describe({ day: dayOf(sentAt), language, short: true })) }</span>
          </span>

          <span className={ styles.chevron } aria-hidden='true'></span>
        </Link>
      );
    });
  }

  return (
    <section className={ styles.card } aria-labelledby='invitations-waiting'>
      <h2 id='invitations-waiting' className={ styles.heading }>
        { text.invitationsWaiting } <span className={ styles.count }>· { waiting.length }</span>
      </h2>

      { rows }
    </section>
  );
}
